"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BcCommonConstants = exports.COMMON_CONSTANTS_NUMBERS = void 0;
exports.COMMON_CONSTANTS_NUMBERS = {
    N0: 0,
    N1: 1,
    N2: 2,
    N3: 3,
    N4: 4,
    N5: 5,
    N6: 6,
    N7: 7,
    N8: 8,
    N9: 9,
    N320: 320,
    N578: 578,
    N1024: 1024,
    N1280: 1280,
    N1440: 1440,
    N10: 10,
    Negative25: -25,
    N100: 100,
};
var BcCommonConstants = (function () {
    function BcCommonConstants() {
    }
    BcCommonConstants.PREFIX_LIB = 'bc';
    BcCommonConstants.ID = 'id';
    BcCommonConstants.DISABLED = 'disabled';
    BcCommonConstants.INDETERMINATED = 'indeterminate';
    BcCommonConstants.DISABLE_CLASS = 'bc-disable';
    BcCommonConstants.HIDDEN = 'hidden';
    BcCommonConstants.TEXT_GRAY = 'text-gray';
    BcCommonConstants.INVISIBLE_CLASS = 'bc-invisible';
    BcCommonConstants.X_SMALL_CLASS = 'bc-xs';
    BcCommonConstants.SMALL = 'small';
    BcCommonConstants.X_SMALL = 'xSmall';
    BcCommonConstants.EVENT_CANCEL = 'cancelSelection';
    BcCommonConstants.EVENT_RANGE = 'selectRange';
    BcCommonConstants.EVENT_SELECT = 'selectDate';
    BcCommonConstants.EVENT_CLICK = 'click';
    BcCommonConstants.EVENT_FOCUS = 'focus';
    BcCommonConstants.EVENT_FOCUSOUT = 'focusout';
    BcCommonConstants.EVENT_BLUR = 'blur';
    BcCommonConstants.EVENT_RESIZE = 'resize';
    BcCommonConstants.ICONS_CLASS = 'bc-icon';
    BcCommonConstants.ICON_XL_CLASS = 'bc-xl';
    BcCommonConstants.ICON_SM_CLASS = 'bc-sm';
    BcCommonConstants.ICON_XS_CLASS = 'bc-xs';
    BcCommonConstants.ICON_ARROW_DOWN = 'arrow2-down';
    BcCommonConstants.ICON_ARROW_LEFT = 'arrow2-left';
    BcCommonConstants.ICON_ARROW_RIGHT = 'arrow2-right';
    BcCommonConstants.ICON_ARROW_UP = 'arrow2-up';
    BcCommonConstants.ICON_ERROR = 'error';
    BcCommonConstants.FADE_OUT_OPACITY = 'fade-out-opacity';
    BcCommonConstants.SLIDE_UP_REVERSE = 'slide-up-reverse';
    BcCommonConstants.BC_BTN_CLASS = 'bc-button';
    BcCommonConstants.BC_LINK_CLASS = 'bc-link';
    BcCommonConstants.BC_BUTTON_ICON_CLASS = 'bc-button-icon';
    BcCommonConstants.BC_TOOLTIP_CLASS = 'bc-tooltip';
    BcCommonConstants.BC_TOOLTIP_TEXT = 'bctooltiptext';
    BcCommonConstants.BC_ALIGN_ITEMS_CENTER_CLASS = 'bc-align-items-center';
    BcCommonConstants.BC_ALIGN_ITEMS_BASELINE_CLASS = 'bc-align-items-baseline';
    BcCommonConstants.BC_TEXT_DECORATION_UNDERLINE = 'bc-text-decoration-underline';
    BcCommonConstants.BTN_PRIMARY_CLASS = 'bc-button-primary';
    BcCommonConstants.BTN_SECONDARY_CLASS = 'bc-button-secondary';
    BcCommonConstants.BTN_TERCIARY_CLASS = 'bc-button-terciary';
    BcCommonConstants.BUTTON_SMALL_CLASS = 'bc-button-small';
    BcCommonConstants.BUTTON_FAB_CLASS = 'bc-fab-button';
    BcCommonConstants.BUTTON_FAB_MINI_CLASS = 'bc-fab-button-mini';
    BcCommonConstants.CONTAINER_CHECKBOX_CLASS = 'bc-container-checkbox';
    BcCommonConstants.CHECKBOX_CLASS = 'bc-checkbox';
    BcCommonConstants.STYLE = 'style';
    BcCommonConstants.DISPLAY = 'display';
    BcCommonConstants.CHECKED = 'checked';
    BcCommonConstants.NONE = 'none';
    BcCommonConstants.BLOCK = 'block';
    BcCommonConstants.FLEX = 'flex';
    BcCommonConstants.OPEN = 'open';
    BcCommonConstants.EVENT_MOUSEDOWN = 'mousedown';
    BcCommonConstants.EVENT_MOUSEOVER = 'mouseover';
    BcCommonConstants.EVENT_MOUSEOUT = 'mouseout';
    BcCommonConstants.EVENT_MOUSEENTER = 'mouseenter';
    BcCommonConstants.EVENT_MOUSELEAVE = 'mouseleave';
    BcCommonConstants.EVENT_MOUSEUP = 'mouseup';
    BcCommonConstants.EVENT_MEMU_ITEMS = 'itemsEvent';
    BcCommonConstants.EVENT_HEADER_TOGGLE_MENU = 'toggleMenu';
    BcCommonConstants.EVENT_HEADER_EXIST = 'headerReady';
    BcCommonConstants.EVENT_MENU_EXIST = 'menuReady';
    BcCommonConstants.EVENT_MENU_ITEM_OPENED = 'itemOpened';
    BcCommonConstants.EVENT_KEY_DOWN = 'keydown';
    BcCommonConstants.EVENT_KEY_UP = 'keyup';
    BcCommonConstants.EVENT_KEY_PRESS = 'keypress';
    BcCommonConstants.EVENT_INPUT = 'input';
    BcCommonConstants.EVENT_CHANGE = 'change';
    BcCommonConstants.EVENT_LOAD = 'load';
    BcCommonConstants.EVENT_SCROLL = 'scroll';
    BcCommonConstants.EVENT_COPY = 'copy';
    BcCommonConstants.EVENT_PASTE = 'paste';
    BcCommonConstants.EVENT_CUT = 'cut';
    BcCommonConstants.KEY_EVENT_ARROW_DOWN = 'ArrowDown';
    BcCommonConstants.KEY_EVENT_ARROW_UP = 'ArrowUp';
    BcCommonConstants.KEY_EVENT_ENTER = 'Enter';
    BcCommonConstants.KEY_EVENT_ESCAPE = 'Escape';
    BcCommonConstants.KEY_EVENT_SPACE = 'Space';
    BcCommonConstants.KEY_EVENT_ARROW_RIGHT = 'ArrowRight';
    BcCommonConstants.KEY_EVENT_ARROW_LEFT = 'ArrowLeft';
    BcCommonConstants.KEY_EVENT_HOME = 'Home';
    BcCommonConstants.KEY_EVENT_END = 'End';
    BcCommonConstants.KEY_EVENT_PAGE_UP = 'PageUp';
    BcCommonConstants.KEY_EVENT_ALT = 'Alt';
    BcCommonConstants.KEY_EVENT_PAGE_DOWN = 'PageDown';
    BcCommonConstants.CLOSE_ALERT_EVENT = 'onCloseAlert';
    BcCommonConstants.CLOSE_NOTIFICATION_EVENT = 'onCloseNotification';
    BcCommonConstants.ARIA_CONTROL = 'aria-controls';
    BcCommonConstants.ARIA_LABEL = 'aria-label';
    BcCommonConstants.ARIA_CURRENT = 'aria-current';
    BcCommonConstants.ARIA_EXPANDED = "aria-expanded";
    BcCommonConstants.ARIA_ACTION_ID = 'aria-action-id';
    BcCommonConstants.BUTTON_TAG = 'button';
    BcCommonConstants.TAG_CLASS = 'bc-tag';
    BcCommonConstants.DIV_TAG = 'div';
    BcCommonConstants.TAG_TAG = 'tag';
    BcCommonConstants.ASIDE_TAG = 'aside';
    BcCommonConstants.SECTION_TAG = 'section';
    BcCommonConstants.OUTLINE_ELEMENT = 'outline-element';
    BcCommonConstants.ARTICLE_TAG = 'article';
    BcCommonConstants.INPUT_TAG = 'input';
    BcCommonConstants.SPAN_TAG = 'span';
    BcCommonConstants.LABEL_TAG = 'label';
    BcCommonConstants.IMG_TAG = 'img';
    BcCommonConstants.EM_TAG = 'em';
    BcCommonConstants.UL_TAG = 'ul';
    BcCommonConstants.LI_TAG = 'li';
    BcCommonConstants.P_TAG = 'p';
    BcCommonConstants.I_TAG = 'i';
    BcCommonConstants.H1_TAG = 'h1';
    BcCommonConstants.H2_TAG = 'h2';
    BcCommonConstants.H3_TAG = 'h3';
    BcCommonConstants.H4_TAG = 'h4';
    BcCommonConstants.H5_TAG = 'h5';
    BcCommonConstants.H6_TAG = 'h6';
    BcCommonConstants.TH_TAG = 'th';
    BcCommonConstants.HREF_TAG = 'a';
    BcCommonConstants.TEXTAREA_TAG = 'textarea';
    BcCommonConstants.ATTR_HREF = 'href';
    BcCommonConstants.CUSTOM_CELL = 'bc-custom-cell';
    BcCommonConstants.BREAKPOINT_XS = exports.COMMON_CONSTANTS_NUMBERS.N320;
    BcCommonConstants.BREAKPOINT_SM = exports.COMMON_CONSTANTS_NUMBERS.N578;
    BcCommonConstants.BREAKPOINT_MD = exports.COMMON_CONSTANTS_NUMBERS.N1024;
    BcCommonConstants.BREAKPOINT_LG = exports.COMMON_CONSTANTS_NUMBERS.N1280;
    BcCommonConstants.BREAKPOINT_XL = exports.COMMON_CONSTANTS_NUMBERS.N1440;
    BcCommonConstants.BC_DROPDOWN_CLASS = 'bc-dropdown';
    BcCommonConstants.BC_DROPDOWN_CUSTOM_CLASS = 'bc-dropdown-custom';
    BcCommonConstants.BC_DROPDOWN_UNDISMISS_CLASS = 'bc-dropdown-undismiss';
    BcCommonConstants.BC_DROPDOWN_CLOSE_BTN_CLASS = 'bc-dropdown-close-button';
    BcCommonConstants.BC_ARROW_DOWN_ICON = 'arrow-down';
    BcCommonConstants.BC_ARROW_UP_ICON = 'arrow-up';
    BcCommonConstants.INPUT_TEXT_TYPE = 'text';
    BcCommonConstants.CURSOR_POINTER = 'pointer';
    BcCommonConstants.MARGIN_LEFT = 'margin-left';
    BcCommonConstants.MARGIN_RIGHT = 'margin-right';
    BcCommonConstants.BORDER_LEFT_WIDTH = 'border-left-width';
    BcCommonConstants.BORDER_RIGHT_WIDTH = 'border-right-width';
    BcCommonConstants.PADDING_LEFT = 'padding-left';
    BcCommonConstants.PADDING_RIGHT = 'padding-right';
    BcCommonConstants.ARIA_SELECTED = 'aria-selected';
    BcCommonConstants.ARIA_POSINSET = 'aria-posinset';
    BcCommonConstants.AFTER_BEGIN = 'afterbegin';
    BcCommonConstants.AFTER_END = 'afterend';
    BcCommonConstants.ROLE = 'role';
    BcCommonConstants.SCROLL = 'scroll';
    BcCommonConstants.KEY_EVENT_ENTER_NUM = '13';
    BcCommonConstants.KEY_EVENT_SPACE_NUM = '32';
    BcCommonConstants.KEY_TAB = 'tab';
    BcCommonConstants.TR_TAG = 'tr';
    BcCommonConstants.TD_TAG = 'td';
    BcCommonConstants.FALSE = false;
    BcCommonConstants.TRUE = true;
    BcCommonConstants.NULL = null;
    BcCommonConstants.UNDEFINED = undefined;
    return BcCommonConstants;
}());
exports.BcCommonConstants = BcCommonConstants;
